import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {
  images: string[] = [
    'assets/imgs/frase1.jpg',
    'assets/imgs/frase2.jpg',
    'assets/imgs/frase3.jpg',
    'assets/imgs/frase4.jpg'
  ];
  currentIndex = 3;
  private intervalId?: any;

  ngOnInit(): void {
    this.intervalId = setInterval(() => this.nextImage(), 3000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  nextImage(): void {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  prevImage(): void {
    this.currentIndex = (this.currentIndex + this.images.length - 1) % this.images.length;
  }

  goToImage(index: number): void {
    this.currentIndex = index;
  }
}
